import { Pipe, PipeTransform } from '@angular/core';

// Types
import { Contact } from '../../types/tables';

@Pipe({ name: 'contactsFilter' })
export class ContactsFilterPipe implements PipeTransform {
  transform(allContacts: Contact[], filter: string): Contact[] {
    if (filter === '' || filter === undefined) {
      return allContacts;
    }

    filter = filter.toLowerCase();

    return allContacts.filter((c: Contact) => {
      if (
        c.surname.toLowerCase().includes(filter) ||
        c.name.toLowerCase().includes(filter) ||
        c.pk.toLocaleLowerCase().includes(filter)
      ) {
        return true;
      }
      return false;
    });
  }
}
